import { SectionLabel, FadeUp } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const PrivacyPage = () => {
  const { t } = useLang();
  const p = t.privacy;

  return (
    <main data-testid="privacy-page" className="bg-midnight">
      <div className="mx-auto max-w-[1680px] px-6 pb-32 pt-32 lg:px-12 lg:pt-44">
        <SectionLabel index="" text="HUDSON & STIR" />
        <FadeUp delay={0.1}>
          <h1 className="mt-8 font-serif text-5xl font-light leading-[1.05] text-ivory md:text-6xl">
            {p.titlePre}<span className="italic text-gold">{p.titleEm}</span>
          </h1>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-lg font-sans text-sm font-light leading-relaxed text-ivory/50">
            {p.intro}
          </p>
          <p className="mt-4 font-sans text-[10px] tracking-[0.3em] text-gold/60">
            {p.updated}
          </p>
        </FadeUp>

        <div className="mt-16 max-w-3xl">
          {p.sections.map((s, i) => (
            <FadeUp key={s.h} delay={0.05 * i}>
              <div
                data-testid={`privacy-section-${i}`}
                className="border-t border-gold/15 py-10"
              >
                <h2 className="font-sans text-[11px] tracking-[0.35em] text-gold">
                  {s.h}
                </h2>
                <p className="mt-5 font-sans text-sm font-light leading-relaxed text-ivory/65">
                  {s.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage;
